import React from 'react';
import useWindowSize from 'utils/hooks';
import PropTypes from 'prop-types';

const Badge = ({ position, image }) => {
  const { width } = useWindowSize();

  switch (position) {
    case 'first':
      return width > 480 ? (
        <svg
          width='120'
          height='104'
          viewBox='0 0 120 104'
          fill='none'
          xmlns='https://www.w3.org/2000/svg'
          xmlnsXlink='https://www.w3.org/1999/xlink'
        >
          <path
            d='M60 91.1575C79.7281 91.1575 95.6893 75.0942 95.6893 55.3181C95.6893 35.542 79.7281 19.4787 60 19.4787C40.2719 19.4787 24.3107 35.542 24.3107 55.3181C24.3107 75.0942 40.2719 91.1575 60 91.1575Z'
            fill='#C4C4C4'
            stroke='#FFD029'
            strokeWidth='7.84933'
          />
          <ellipse cx='60' cy='55.3181' rx='31.7646' ry='31.9148' fill='url(#pattern0)' />
          <path
            d='M73.2216 9.03022C70.2988 9.03022 70.0269 5.7782 70.0269 5.19007H69.9929C69.8229 5.74361 68.7354 9.03022 64.7929 9.03022C61.1903 9.03022 60.2726 5.25926 60.0687 4.01381C60.0687 3.94462 59.9668 3.94462 59.9668 4.01381C59.7628 5.25926 58.8112 9.03022 55.2426 9.03022C51.3001 9.03022 50.2125 5.74361 50.0426 5.19007H50.0086C49.9746 5.7782 49.7367 9.03022 46.8139 9.03022C43.5851 9.03022 43.0073 6.33174 43.0073 6.33174L45.9302 18.0598H60.0007H74.1053L77.0282 6.33174C77.0282 6.29714 76.4164 9.03022 73.2216 9.03022Z'
            fill='#FFBE00'
          />
          <path d='M74.1386 18.0244H45.8955V22.7295H74.1386V18.0244Z' fill='#FFBC00' />
          <path d='M74.1386 18.0244H45.8955V19.7888H74.1386V18.0244Z' fill='#FFF100' />
          <path d='M74.1386 18.0244H45.8955V19.7888H74.1386V18.0244Z' fill='#FFF100' />
          <path d='M74.105 18.0244H60.0005V22.7295H74.105V18.0244Z' fill='#F78D0C' />
          <path d='M74.105 18.0244H60.0005V19.7888H74.105V18.0244Z' fill='#FFBC00' />
          <path
            d='M74.139 18.0249L77.0279 6.33146C76.9599 6.60822 76.2462 9.02994 73.2214 9.02994C70.2985 9.02994 70.0266 5.77792 70.0266 5.18979H69.9926C69.8227 5.74333 68.7351 9.02994 64.7926 9.02994C61.19 9.02994 60.2724 5.25898 60.0685 4.01353C60.0685 3.97893 60.0345 3.94434 60.0005 3.94434V18.0249H74.139Z'
            fill='#F78D0C'
          />
          <path
            d='M60.0006 0L58.6411 3.07904L60.0006 4.35909L61.3601 3.07904L60.0006 0Z'
            fill='#FFBC00'
          />
          <path d='M61.3603 3.07904L60.0005 0V4.35909L61.3603 3.07904Z' fill='#F78D0C' />
          <path
            d='M69.9586 1.17578L68.5991 4.25482L69.9586 5.53487L71.3181 4.25482L69.9586 1.17578Z'
            fill='#FFBC00'
          />
          <path d='M71.3183 4.25482L69.9585 1.17578V5.53487L71.3183 4.25482Z' fill='#F78D0C' />
          <path
            d='M50.0421 1.17578L48.6826 4.25482L50.0421 5.53487L51.4016 4.25482L50.0421 1.17578Z'
            fill='#FFBC00'
          />
          <path d='M51.4018 4.25482L50.042 1.17578V5.53487L51.4018 4.25482Z' fill='#F78D0C' />
          <path
            d='M77.6054 2.87207L75.7021 5.57055L76.7897 7.12737L78.3531 6.19328L77.6054 2.87207Z'
            fill='#FFBC00'
          />
          <path
            d='M78.3539 6.19328L77.6059 2.87207L76.79 7.12737L78.3539 6.19328Z'
            fill='#F78D0C'
          />
          <path
            d='M42.4292 2.87207L44.2984 5.57055L43.2109 7.12737L41.6475 6.19328L42.4292 2.87207Z'
            fill='#FFBC00'
          />
          <path
            d='M42.4292 2.87207L43.2109 7.12737L44.2985 5.57055L42.4292 2.87207Z'
            fill='#F78D0C'
          />
          <path
            d='M62.2093 13.4925C62.2093 15.3607 61.2237 16.8829 60.0002 16.8829C58.7766 16.8829 57.791 15.3607 57.791 13.4925C57.791 11.6244 58.7766 10.1021 60.0002 10.1021C61.2237 10.0675 62.2093 11.5898 62.2093 13.4925Z'
            fill='#BD1E2D'
          />
          <path
            d='M60.0005 10.0674V16.8828C61.224 16.8828 62.2096 15.3606 62.2096 13.4924C62.2096 11.6242 61.224 10.0674 60.0005 10.0674Z'
            fill='#961E2D'
          />
          <path
            d='M70.5022 13.7344C70.5022 14.7723 69.9584 15.6026 69.2787 15.6026C68.599 15.6026 68.0552 14.7723 68.0552 13.7344C68.0552 12.6965 68.599 11.8662 69.2787 11.8662C69.9584 11.8662 70.5022 12.6965 70.5022 13.7344Z'
            fill='#BD1E2D'
          />
          <path
            d='M69.2788 11.8662V15.6026C69.9587 15.6026 70.5027 14.7723 70.5027 13.7344C70.5027 12.6965 69.9587 11.8662 69.2788 11.8662Z'
            fill='#961E2D'
          />
          <path
            d='M50.7216 15.6026C51.3973 15.6026 51.9451 14.7662 51.9451 13.7344C51.9451 12.7026 51.3973 11.8662 50.7216 11.8662C50.0458 11.8662 49.498 12.7026 49.498 13.7344C49.498 14.7662 50.0458 15.6026 50.7216 15.6026Z'
            fill='#BD1E2D'
          />
          <path
            d='M50.7222 11.8662V15.6026C51.4021 15.6026 51.946 14.7723 51.946 13.7344C51.946 12.6965 51.4021 11.8662 50.7222 11.8662Z'
            fill='#961E2D'
          />
          <path
            d='M58.811 11.3821C58.811 11.4859 58.845 11.5897 58.879 11.6934C58.981 11.7626 59.049 11.7626 59.185 11.7626C59.491 11.7626 59.7629 11.4859 59.7629 11.1745C59.7629 11.0707 59.7289 10.9669 59.6949 10.8631C59.5929 10.7939 59.525 10.7939 59.389 10.7939C59.049 10.7939 58.811 11.0361 58.811 11.3821Z'
            fill='white'
          />
          <path
            d='M68.5654 12.6278C68.5654 12.697 68.5994 12.7316 68.5994 12.8008C68.6334 12.8353 68.7014 12.8353 68.7694 12.8353C68.9394 12.8353 69.0754 12.697 69.0754 12.524C69.0754 12.4548 69.0414 12.4202 69.0414 12.351C69.0074 12.3164 68.9394 12.3164 68.8714 12.3164C68.7014 12.3164 68.5654 12.4548 68.5654 12.6278Z'
            fill='white'
          />
          <path
            d='M50.042 12.6278C50.042 12.697 50.076 12.7316 50.076 12.8008C50.11 12.8353 50.178 12.8353 50.246 12.8353C50.4159 12.8353 50.5519 12.697 50.5519 12.524C50.5519 12.4548 50.5179 12.4202 50.5179 12.351C50.4839 12.3164 50.4159 12.3164 50.348 12.3164C50.178 12.3164 50.042 12.4548 50.042 12.6278Z'
            fill='white'
          />
          <rect
            x='36.5674'
            y='79.2989'
            width='47.262'
            height='22.2503'
            rx='11.1251'
            fill='#E0A42D'
            stroke='#FFD029'
            strokeWidth='3.10144'
          />
          <path
            d='M55.0338 85.3348V95.1348H53.2138V86.8608H51.1418V85.3348H55.0338ZM59.8198 95.2328C59.2131 95.2328 58.6205 95.1534 58.0418 94.9948C57.4631 94.8361 57.0011 94.6354 56.6558 94.3928L57.3278 93.0628C57.6638 93.2868 58.0651 93.4688 58.5318 93.6088C59.0078 93.7394 59.4745 93.8048 59.9318 93.8048C60.9771 93.8048 61.4998 93.5294 61.4998 92.9788C61.4998 92.7174 61.3645 92.5354 61.0938 92.4328C60.8325 92.3301 60.4078 92.2321 59.8198 92.1388C59.2038 92.0454 58.6998 91.9381 58.3078 91.8168C57.9251 91.6954 57.5891 91.4854 57.2998 91.1868C57.0198 90.8788 56.8798 90.4541 56.8798 89.9128C56.8798 89.2034 57.1738 88.6388 57.7618 88.2188C58.3591 87.7894 59.1618 87.5748 60.1698 87.5748C60.6832 87.5748 61.1965 87.6354 61.7098 87.7568C62.2231 87.8688 62.6431 88.0228 62.9698 88.2188L62.2978 89.5488C61.6631 89.1754 60.9491 88.9888 60.1558 88.9888C59.6425 88.9888 59.2505 89.0681 58.9798 89.2268C58.7185 89.3761 58.5878 89.5768 58.5878 89.8288C58.5878 90.1088 58.7278 90.3094 59.0078 90.4308C59.2971 90.5428 59.7405 90.6501 60.3378 90.7528C60.9351 90.8461 61.4252 90.9534 61.8078 91.0748C62.1905 91.1961 62.5171 91.4014 62.7878 91.6908C63.0678 91.9801 63.2078 92.3908 63.2078 92.9228C63.2078 93.6228 62.9045 94.1828 62.2978 94.6028C61.6912 95.0228 60.8652 95.2328 59.8198 95.2328ZM69.2089 94.7288C69.0036 94.8968 68.7516 95.0228 68.4529 95.1068C68.1636 95.1908 67.8556 95.2328 67.5289 95.2328C66.7076 95.2328 66.0729 95.0181 65.6249 94.5888C65.1769 94.1594 64.9529 93.5341 64.9529 92.7128V89.1148H63.7209V87.7148H64.9529V86.0068H66.7029V87.7148H68.7049V89.1148H66.7029V92.6708C66.7029 93.0348 66.7916 93.3148 66.9689 93.5108C67.1462 93.6974 67.4029 93.7908 67.7389 93.7908C68.1309 93.7908 68.4576 93.6881 68.7189 93.4828L69.2089 94.7288Z'
            fill='white'
          />
          <rect
            x='98.8237'
            y='44.6807'
            width='21.1764'
            height='4.65424'
            rx='2.32712'
            fill='#FFD029'
          />
          <rect
            x='98.8237'
            y='52.6602'
            width='15.401'
            height='4.65424'
            rx='2.32712'
            fill='#FFD029'
          />
          <rect
            x='98.8237'
            y='61.3027'
            width='9.62565'
            height='4.65424'
            rx='2.32712'
            fill='#FFD029'
          />
          <rect
            width='21.1764'
            height='4.65424'
            rx='2.32712'
            transform='matrix(-1 0 0 1 21.1763 44.6807)'
            fill='#FFD029'
          />
          <rect
            width='15.401'
            height='4.65424'
            rx='2.32712'
            transform='matrix(-1 0 0 1 21.1768 52.6602)'
            fill='#FFD029'
          />
          <rect
            width='9.62565'
            height='4.65424'
            rx='2.32712'
            transform='matrix(-1 0 0 1 21.1768 61.3027)'
            fill='#FFD029'
          />
          <defs>
            <pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'>
              <use href='#image1' transform='translate(-0.00236306) scale(0.00502363)' />
            </pattern>
            <image id='image1' width='200' height='200' href={image} />
          </defs>
        </svg>
      ) : (
        <svg
          width='80'
          height='45'
          viewBox='0 0 80 45'
          fill='none'
          xmlns='https://www.w3.org/2000/svg'
          xmlnsXlink='https://www.w3.org/1999/xlink'
        >
          <circle cx='39.9995' cy='20' r='20' fill='#FFD029' />
          <circle cx='39.9995' cy='20' r='20' stroke='#FFD029' />
          <rect
            x='58.3174'
            y='9.32129'
            width='21.4089'
            height='4.68446'
            rx='2.34223'
            fill='#FFD029'
          />
          <rect
            x='59.999'
            y='17.3525'
            width='15.5701'
            height='4.68446'
            rx='2.34223'
            fill='#FFD029'
          />
          <rect
            x='58.3174'
            y='26.0518'
            width='9.73133'
            height='4.68446'
            rx='2.34223'
            fill='#FFD029'
          />
          <rect
            width='21.4089'
            height='4.68446'
            rx='2.34223'
            transform='matrix(-1 0 0 1 21.9985 9.32129)'
            fill='#FFD029'
          />
          <rect
            width='15.5701'
            height='4.68446'
            rx='2.34223'
            transform='matrix(-1 0 0 1 19.999 17.3525)'
            fill='#FFD029'
          />
          <rect
            width='9.73133'
            height='4.68446'
            rx='2.34223'
            transform='matrix(-1 0 0 1 21.8154 26.0518)'
            fill='#FFD029'
          />
          <circle cx='40' cy='20' r='18' fill='url(#pattern0)' />
          <rect
            x='32.9995'
            y='33'
            width='15'
            height='11'
            rx='5.5'
            fill='#E0A42D'
            stroke='#FFD029'
            strokeWidth='2'
          />
          <path d='M41.2875 35.4V41H40.2475V36.272H39.0635V35.4H41.2875Z' fill='white' />
          <defs>
            <pattern id='pattern0' patternContentUnits='objectBoundingBox' width='1' height='1'>
              <use xlinkHref='#image0' transform='scale(0.005)' />
            </pattern>
            <image id='image0' width='200' height='200' xlinkHref={image} />
          </defs>
        </svg>
      );
    case 'second':
      return width > 480 ? (
        <svg
          width='80'
          height='92'
          viewBox='0 0 80 92'
          fill='none'
          xmlns='https://www.w3.org/2000/svg'
          xmlnsXlink='https://www.w3.org/1999/xlink'
        >
          <path
            d='M40 76.6534C59.8824 76.6534 75.9247 60.3642 75.9247 40.3643C75.9247 20.3645 59.8824 4.07533 40 4.07533C20.1176 4.07533 4.07533 20.3645 4.07533 40.3643C4.07533 60.3642 20.1176 76.6534 40 76.6534Z'
            fill='#78CDDB'
            stroke='#78CDDB'
            strokeWidth='7.84933'
          />
          <ellipse cx='40' cy='40.3643' rx='32' ry='32.3643' fill='url(#pattern2)' />
          <rect
            x='12.3155'
            y='63.5928'
            width='55.4673'
            height='25.9588'
            rx='12.9794'
            fill='#01B4D5'
            stroke='#78CDDB'
            strokeWidth='3.10144'
          />
          <path
            d='M35.0944 80.1084V81.6484H27.8704V80.4304L31.7624 76.7344C32.201 76.3144 32.495 75.9504 32.6444 75.6424C32.803 75.3251 32.8824 75.0124 32.8824 74.7044C32.8824 74.2471 32.7284 73.8971 32.4204 73.6544C32.1124 73.4118 31.6597 73.2904 31.0624 73.2904C30.0637 73.2904 29.2984 73.6311 28.7664 74.3124L27.4924 73.3324C27.875 72.8191 28.3884 72.4224 29.0324 72.1424C29.6857 71.8531 30.4137 71.7084 31.2164 71.7084C32.2804 71.7084 33.1297 71.9604 33.7644 72.4644C34.399 72.9684 34.7164 73.6544 34.7164 74.5224C34.7164 75.0544 34.6044 75.5538 34.3804 76.0204C34.1564 76.4871 33.727 77.0191 33.0924 77.6164L30.4744 80.1084H35.0944ZM40.9188 74.0884C41.8615 74.0884 42.6175 74.3638 43.1868 74.9144C43.7561 75.4651 44.0408 76.2818 44.0408 77.3644V81.6484H42.2908V77.5884C42.2908 76.9351 42.1368 76.4451 41.8288 76.1184C41.5208 75.7824 41.0821 75.6144 40.5128 75.6144C39.8688 75.6144 39.3601 75.8104 38.9868 76.2024C38.6135 76.5851 38.4268 77.1404 38.4268 77.8684V81.6484H36.6768V74.1724H38.3428V75.1384C38.6321 74.7931 38.9961 74.5318 39.4348 74.3544C39.8735 74.1771 40.3681 74.0884 40.9188 74.0884ZM53.6512 71.2604V81.6484H51.9712V80.6824C51.6818 81.0371 51.3225 81.3031 50.8932 81.4804C50.4732 81.6578 50.0065 81.7464 49.4932 81.7464C48.7745 81.7464 48.1258 81.5878 47.5472 81.2704C46.9778 80.9531 46.5298 80.5051 46.2032 79.9264C45.8765 79.3384 45.7132 78.6664 45.7132 77.9104C45.7132 77.1544 45.8765 76.4871 46.2032 75.9084C46.5298 75.3298 46.9778 74.8818 47.5472 74.5644C48.1258 74.2471 48.7745 74.0884 49.4932 74.0884C49.9878 74.0884 50.4405 74.1724 50.8512 74.3404C51.2618 74.5084 51.6118 74.7604 51.9012 75.0964V71.2604H53.6512ZM49.7032 80.2484C50.1232 80.2484 50.5012 80.1551 50.8372 79.9684C51.1732 79.7724 51.4392 79.4971 51.6352 79.1424C51.8312 78.7878 51.9292 78.3771 51.9292 77.9104C51.9292 77.4438 51.8312 77.0331 51.6352 76.6784C51.4392 76.3238 51.1732 76.0531 50.8372 75.8664C50.5012 75.6704 50.1232 75.5724 49.7032 75.5724C49.2832 75.5724 48.9052 75.6704 48.5692 75.8664C48.2332 76.0531 47.9672 76.3238 47.7712 76.6784C47.5752 77.0331 47.4772 77.4438 47.4772 77.9104C47.4772 78.3771 47.5752 78.7878 47.7712 79.1424C47.9672 79.4971 48.2332 79.7724 48.5692 79.9684C48.9052 80.1551 49.2832 80.2484 49.7032 80.2484Z'
            fill='white'
          />
          <defs>
            <pattern id='pattern2' patternContentUnits='objectBoundingBox' width='1' height='1'>
              <use href='#image2' transform='translate(-0.0056929) scale(0.00505693)' />
            </pattern>
            <image id='image2' width='200' height='200' href={image} />
          </defs>
        </svg>
      ) : (
        <svg
          width='40'
          height='45'
          viewBox='0 0 40 45'
          fill='none'
          xmlns='https://www.w3.org/2000/svg'
          xmlnsXlink='https://www.w3.org/1999/xlink'
        >
          <circle cx='20' cy='20' r='20' fill='#78CDDB' />
          <circle cx='20' cy='20' r='20' stroke='#78CDDB' />
          <circle cx='20.0005' cy='20' r='18' fill='url(#pattern2)' />
          <rect
            x='13'
            y='33'
            width='15'
            height='11'
            rx='5.5'
            fill='#01B4D5'
            stroke='#78CDDB'
            strokeWidth='2'
          />
          <path
            d='M22.408 40.12V41H18.28V40.304L20.504 38.192C20.7547 37.952 20.9227 37.744 21.008 37.568C21.0987 37.3867 21.144 37.208 21.144 37.032C21.144 36.7707 21.056 36.5707 20.88 36.432C20.704 36.2933 20.4453 36.224 20.104 36.224C19.5333 36.224 19.096 36.4187 18.792 36.808L18.064 36.248C18.2827 35.9547 18.576 35.728 18.944 35.568C19.3173 35.4027 19.7333 35.32 20.192 35.32C20.8 35.32 21.2853 35.464 21.648 35.752C22.0107 36.04 22.192 36.432 22.192 36.928C22.192 37.232 22.128 37.5173 22 37.784C21.872 38.0507 21.6267 38.3547 21.264 38.696L19.768 40.12H22.408Z'
            fill='white'
          />
          <defs>
            <pattern id='pattern2' patternContentUnits='objectBoundingBox' width='1' height='1'>
              <use xlinkHref='#image2' transform='scale(0.005)' />
            </pattern>
            <image id='image2' width='200' height='200' xlinkHref={image} />
          </defs>
        </svg>
      );
    case 'third':
      return width > 480 ? (
        <svg
          xmlns='https://www.w3.org/2000/svg'
          width='80'
          height='92'
          viewBox='0 0 80 92'
          fill='none'
        >
          <path
            d='M40 76.7C59.9 76.7 75.9 60.4 75.9 40.4 75.9 20.4 59.9 4.1 40 4.1 20.1 4.1 4.1 20.4 4.1 40.4 4.1 60.4 20.1 76.7 40 76.7Z'
            style={{ fill: '#F2667F', strokeWidth: 8, stroke: '#F2667F' }}
          />
          <ellipse cx='40' cy='40.4' rx='32' ry='32.4' fill='url(#pattern3)' />
          <rect
            x='12.3'
            y='63.6'
            width='55.5'
            height='26'
            rx='13'
            style={{ fill: '#B11616', strokeWidth: 3, stroke: '#F2667F' }}
          />
          <path
            d='M35.1 75.9C36 76 36.7 76.3 37.2 76.8 37.7 77.3 37.9 78 37.9 78.7 37.9 79.3 37.8 79.8 37.5 80.3 37.2 80.7 36.8 81.1 36.2 81.4 35.6 81.7 34.9 81.8 34 81.8 33.3 81.8 32.7 81.7 32 81.5 31.4 81.3 30.8 81 30.4 80.7L31.1 79.2C31.5 79.5 31.9 79.8 32.4 80 32.9 80.1 33.5 80.2 34 80.2 34.7 80.2 35.2 80.1 35.5 79.8 35.9 79.5 36.1 79.2 36.1 78.7 36.1 78.3 35.9 77.9 35.6 77.7 35.2 77.4 34.7 77.3 34 77.3H33.1V76L35.3 73.4H30.8V71.8H37.5V73.1L35.1 75.9ZM41.3 75.3C41.8 74.5 42.7 74.1 44 74.1V75.8C43.8 75.7 43.7 75.7 43.6 75.7 42.9 75.7 42.4 75.9 42 76.3 41.6 76.7 41.4 77.3 41.4 78V81.6H39.6V74.2H41.3V75.3ZM52.7 71.3V81.6H51V80.7C50.7 81 50.4 81.3 49.9 81.5 49.5 81.7 49.1 81.7 48.5 81.7 47.8 81.7 47.2 81.6 46.6 81.3 46 81 45.6 80.5 45.3 79.9 44.9 79.3 44.8 78.7 44.8 77.9 44.8 77.2 44.9 76.5 45.3 75.9 45.6 75.3 46 74.9 46.6 74.6 47.2 74.2 47.8 74.1 48.5 74.1 49 74.1 49.5 74.2 49.9 74.3 50.3 74.5 50.7 74.8 51 75.1V71.3H52.7ZM48.8 80.2C49.2 80.2 49.6 80.2 49.9 80 50.2 79.8 50.5 79.5 50.7 79.1 50.9 78.8 51 78.4 51 77.9 51 77.4 50.9 77 50.7 76.7 50.5 76.3 50.2 76.1 49.9 75.9 49.6 75.7 49.2 75.6 48.8 75.6 48.3 75.6 48 75.7 47.6 75.9 47.3 76.1 47 76.3 46.8 76.7 46.6 77 46.5 77.4 46.5 77.9 46.5 78.4 46.6 78.8 46.8 79.1 47 79.5 47.3 79.8 47.6 80 48 80.2 48.3 80.2 48.8 80.2Z'
            fill='white'
          />
          <defs>
            <pattern id='pattern3' patternContentUnits='objectBoundingBox' width='1' height='1'>
              <use href='#image3' transform='translate(-0.0056929)scale(0.00505693)' />
            </pattern>
            <image id='image3' width='200' height='200' href={image} />
          </defs>
        </svg>
      ) : (
        <svg
          width='40'
          height='45'
          viewBox='0 0 40 45'
          fill='none'
          xmlns='https://www.w3.org/2000/svg'
          xmlnsXlink='https://www.w3.org/1999/xlink'
        >
          <circle cx='20' cy='20' r='20' fill='#F2667F' />
          <circle cx='20' cy='20' r='20' stroke='#F2667F' />
          <circle cx='20.0005' cy='20' r='18' fill='url(#pattern3)' />
          <rect
            x='13'
            y='33'
            width='15'
            height='11'
            rx='5.5'
            fill='#B11616'
            stroke='#F2667F'
            strokeWidth='2'
          />
          <path
            d='M20.736 37.712C21.2533 37.776 21.648 37.952 21.92 38.24C22.192 38.528 22.328 38.888 22.328 39.32C22.328 39.6453 22.2453 39.9413 22.08 40.208C21.9147 40.4747 21.664 40.688 21.328 40.848C20.9973 41.0027 20.592 41.08 20.112 41.08C19.712 41.08 19.3253 41.024 18.952 40.912C18.584 40.7947 18.2693 40.6347 18.008 40.432L18.456 39.624C18.6587 39.7947 18.904 39.9307 19.192 40.032C19.4853 40.128 19.7867 40.176 20.096 40.176C20.464 40.176 20.752 40.1013 20.96 39.952C21.1733 39.7973 21.28 39.5893 21.28 39.328C21.28 39.0667 21.1787 38.864 20.976 38.72C20.7787 38.5707 20.4747 38.496 20.064 38.496H19.552V37.784L20.824 36.272H18.28V35.4H22.096V36.096L20.736 37.712Z'
            fill='white'
          />
          <defs>
            <pattern id='pattern3' patternContentUnits='objectBoundingBox' width='1' height='1'>
              <use xlinkHref='#image3' transform='scale(0.005)' />
            </pattern>
            <image id='image3' width='200' height='200' xlinkHref={image} />
          </defs>
        </svg>
      );

    default:
      return null;
  }
};

Badge.propTypes = {
  position: PropTypes.oneOf(['first', 'second', 'third']).isRequired,
  image: PropTypes.string.isRequired // url of image
};

export default Badge;
